var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6346 39H18.3504C18.254 38.9722 18.1555 38.9521 18.056 38.94C15.6832 38.801 13.3615 38.193 11.225 37.1512C5.24452 34.2063 1.58644 29.4508 0.305294 22.9065C0.16355 22.1539 0.0981302 21.3958 0 20.6487V18.3636C0 18.2491 0.0545168 18.1455 0.0654202 18.0309C0.22638 15.3404 0.988312 12.7203 2.29516 10.3632C5.88236 3.96613 11.3613 0.486741 18.6775 0.0395465C22.1338 -0.190687 25.5826 0.587979 28.605 2.28097C35.0161 5.85853 38.4998 11.3503 38.9632 18.6799C39.185 22.1492 38.4013 25.6089 36.7062 28.6436C35.3381 31.2757 33.3796 33.5553 30.9838 35.3037C28.5881 37.0522 25.8202 38.2221 22.8971 38.7219C22.1447 38.8364 21.3869 38.9018 20.6346 39ZM29.1447 28.1528V13.5863L28.654 13.968C25.9282 16.1495 23.2024 18.2709 20.531 20.4469C20.2323 20.7348 19.8337 20.8957 19.4189 20.8957C19.0041 20.8957 18.6054 20.7348 18.3067 20.4469C15.5155 18.3091 12.7133 16.1931 9.91115 14.0716L9.52954 13.799V28.1419L29.1447 28.1528ZM28.2561 10.854H10.4291L19.4898 17.7855L28.2561 10.854Z",
    fill: "#E41F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ac7d78bad381f901f6501ac208f9ec49.svg";
export { ForwardRef as ReactComponent };